module.exports = __webpack_public_path__ + "img/Dispensing Separation.922bdcc1.jpg";